import React, { Fragment, useEffect, useState } from "react";
import { Col, Table, Container } from "react-bootstrap";
import classes from "../WebsiteManagement/websiteManagement.module.css";
import { GetLatestOtps } from "../../entities/action/action";

const formatDate = (value) => {
  if (!value) return "-";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return value;
  return date.toLocaleString();
};

const OtpList = () => {
  const [dataSet, setDataSet] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      setLoading(true);
      const res = await GetLatestOtps();
      if (res.success && res.otps) {
        setDataSet(res.otps);
      } else {
        setDataSet([]);
      }
      setLoading(false);
    })();
  }, []);

  return (
    <Fragment>
      <Container fluid style={{ marginTop: "2vh" }}>
        <Col lg={12} className={classes.Response2}>
          {loading ? (
            <p>Loading OTPs...</p>
          ) : (
            <Table striped bordered hover>
              <thead>
                <tr>
                  <th>S.No</th>
                  <th>Customer Name</th>
                  <th>Phone Number</th>
                  <th>Email</th>
                  <th>OTP</th>
                  <th>Created At</th>
                </tr>
              </thead>
              <tbody>
                {dataSet.length > 0 ? (
                  dataSet.map((row, key) => (
                    <tr key={key}>
                      <td>{key + 1}</td>
                      <td>{row.customerName || "-"}</td>
                      <td>{row.phone || "-"}</td>
                      <td>{row.email || "-"}</td>
                      <td>{row.otp || "-"}</td>
                      <td>{formatDate(row.created)}</td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan={6} style={{ textAlign: "center" }}>
                      No OTP records found
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>
          )}
        </Col>
      </Container>
    </Fragment>
  );
};

export default OtpList;
